import * as React from "react";
import GeneralTable from "../../components/GridTable";
import { COLUMNS } from "./constants";
import Layout from "../../components/Layout";
import { useCompanyStore } from "../../services/company";
import AddHRDialog from "./AddHRDialog";
import { useHRStore } from "../../services/hr";
import { useCorporateStore } from "../../services/corporates";
import { MODULES } from "../../utils/constants";

export default function HRList() {
  const { data, totalPages, currentPage, total, rows, isLoading, fetchGrid, setFilters, onPageChange, onDelete } = useHRStore();
  const { globalCompanyId } = useCompanyStore();
  const { allData: corporates, fetchAll } = useCorporateStore();

  React.useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  React.useEffect(() => {
    if (globalCompanyId) {
      setFilters({ corporateId: globalCompanyId })
    } else {
      fetchGrid()
    }
  }, [globalCompanyId, fetchGrid, setFilters])

  const dataWithCorporateName = React.useMemo(() => {
    const corporateNameById = new Map(
      corporates.map((corporate: any) => [
        corporate._id,
        corporate.companyName || corporate.name || corporate._id,
      ])
    );

    return data.map((row: any) => ({
      ...row,
      corporateName: corporateNameById.get(row.corporateId || '') || row.corporateId,
    }));
  }, [corporates, data]);



  return (
    <Layout appBarTitle="HR">
      <Layout.Header component={AddHRDialog} props={{ module: MODULES.HR }} />
      <Layout.Body
        component={GeneralTable}
        props={{
          data: dataWithCorporateName,
          columns: COLUMNS,  
          currentPage,
          totalPages,
          total,
          rows,
          loading: isLoading,
          onPageChange,
          module: MODULES.HR,
          onDelete: (data: any) => onDelete(data._id)
        }}
      />


    </Layout>
  )
}
